import type { IconName } from "@similarweb/icons";
import type { ReactElement } from "react";

import { StyledIcon, StyledIconWithLabel } from "./styles";

type Props = {
    className?: string;
    iconName: IconName;
    label: ReactElement | string;
    dataAutomation?: string;
};

function IconWithLabel(props: Props) {
    const { iconName, label, className, dataAutomation } = props;

    return (
        <StyledIconWithLabel
            className={className}
            data-automation={dataAutomation}
        >
            <StyledIcon
                iconName={iconName}
                size="xs"
            />
            {label}
        </StyledIconWithLabel>
    );
}

export default IconWithLabel;
